<template>
    <main id="hcid-wrapper">
        <div id="hcid-page" class="pb-4">
            <breadcrumb :breadcrumb="[
                { title: 'Community', url: app_url + '/', status: false },
                {
                    title: 'Profile HCID',
                    url: app_url + '/hcid',
                    status: true
                }
            ]"></breadcrumb>
            <ModalQR :cardNumber="qr.cardNumber" :size="qr.size" level="H" :user="user"></ModalQR>
            <ModalBarCode :cardNumber="qr.cardNumber" :size="qr.size" level="H" :user="user"></ModalBarCode>
            <div class="container-fluid title-row">
                <div class="container py-5">
                    <div class="row">
                        <div class="col">
                            <h2 class="title">Honda Community ID</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container py-4">
                <div class="card card-info">
                    <div class="card-body">
                        <div class="row">
                            <a :href="app_url + '/hcid'" class="btn btn-red py-2 my-2">Biodata</a>
                            <div class="col my-2">
                                <hr class="divider-hr" />
                            </div>
                            <a :href="app_url + '/hcid/kopdar'" class="btn btn-black py-2 my-2">Kopdar</a>
                            <div class="col my-2">
                                <hr class="divider-hr" />
                            </div>
                            <a :href="app_url + '/hcid/kta'" class="btn btn-black py-2 my-2">KTA</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container my-4">
                <div class="card card-info">
                    <div class="card-body card-mobile">
                        <div class="row justify-content-between">
                            <div class="col-md-9 align-self-center">
                                <div class="row">
                                    <div class="col col-sm-3 col-profile-image">
                                        <div class="profile-image" :style="{
                backgroundImage:
                    'url(' + user.avatar + ')'
            }">
                                            <div v-if="uploadloader" class="loading loading-double"></div>
                                            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                                                @vdropzone-success="uploadedCompleted
                " @vdropzone-sending="sendingFile" @vdropzone-error="uploadError"></vue-dropzone>
                                        </div>
                                        <div v-if="showuploaderror" class="error-upload">
                                            {{ errormessage }}
                                        </div>
                                    </div>
                                    <div class="col col-profile">
                                        <div class="box-profile">
                                            <div class="row row-name">
                                                <div class="col">
                                                    <span>{{ user.name }}</span>
                                                </div>
                                            </div>
                                            <div class="row row-club">
                                                <div class="col">
                                                    <span>{{ user.club }}</span>
                                                </div>
                                            </div>
                                            <div class="row py-2">
                                                <div class="col">
                                                    <a :href="app_url +
                '/profile/edit'
                " class="btn btn-tukar">Edit Profil</a>
                                                    <a :href="app_url +
                '/profile/edit-account'
                " class="btn btn-tukar">Edit Email / No. HP /
                                                        PIN</a>
                                                    <a @click="seeQrCodeTracker
                " data-toggle="modal" data-target="#modalVirtualCard" class="btn btn-view"><i
                                                            class="fa fa-qrcode fa-lg pr-2"></i>Lihat QR code</a>
                                                    <a @click="seeBarCodeTracker
                " data-toggle="modal" data-target="#modalVirtualBarcode" class="btn btn-view"><i
                                                            class="fa fa-barcode fa-lg pr-2"></i>Lihat Bar Code</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 text-center py-3 box-point">
                                <div class="row">
                                    <div class="col">
                                        <span>Poin Saya</span>
                                    </div>
                                </div>
                                <div class="row py-2">
                                    <div class="col">
                                        <div class="boxcoin">
                                            <span class="coin"></span>
                                            <h2 class="d-inline-flex" id="poin-amount">
                                                {{ currentPoint }}
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <a :href="app_url + '/history-point'" class="btn btn-tukar">Lihat Transaksi</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container my-5">
                <div class="row justify-content-center">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col">
                                <h2 class="title">Event</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <span class="sub-title py-2 mr-4">Event akan datang</span>
                                <a class="sub-title py-2" :href="app_url + '/checklist-join-event'">Checklist join
                                    event</a>
                            </div>
                        </div>
                        <HcidEventCard />
                        <div class="row py-5">
                            <div class="col text-center">
                                <a @click="gtmTrackerBtn('Event')" :href="app_url + '/event'"
                                    class="btn btn-see-more">See More</a>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col">
                                <h2 class="title">Games</h2>
                            </div>
                        </div>
                        <Games :noCarousel="false" /> -->
                        <div class="row py-4">
                            <div class="col-sm-12 col-title transaction-redeem">
                                <h2 class="title-list-transaksi">
                                    Daftar Transaksi
                                </h2>
                                <a @click="redeemPointTracker" :href="app_url + '/tukar-poin'"
                                    class="btn btn-redeem">Redeem Poin</a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <hr class="hr-transaksi" />
                                <span :class="[
                titleClass,
                selectedTitle == 'earn'
                    ? 'selected-list-transaction'
                    : ''
            ]" @click="changeSelectedClass('earn')">Penambahan Poin</span>
                                <span :class="[
                titleClass,
                selectedTitle == 'redeem'
                    ? 'selected-list-transaction'
                    : ''
            ]" @click="changeSelectedClass('redeem')">Pengurangan Poin</span>
                                <hr class="hr-transaksi" />
                            </div>
                        </div>
                        <div class="row py-2 mb-2">
                            <div v-if="loaderpoint" class="loading loading-double"></div>
                            <div v-else class="col">
                                <div v-if="points.length > 0">
                                    <div class="row py-2" v-for="(point, i) in points" :key="i">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row align-items-end">
                                                        <div class="col-md-1 col-left text-center">
                                                            <span class="coin"><span class="poin-value">{{
                point.point
            }}</span></span>
                                                            <span class="poin-text">Point</span>
                                                        </div>
                                                        <div class="col">
                                                            <span class="date-content">{{
                    point.date
                }}</span>
                                                            <h3 class="title-content">
                                                                {{
                                                                point.noted
                                                                }}
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="messagebox">
                                    <h4>Belum ada transaksi poin</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import ModalQR from "../../widget/ModalQR";
import ModalBarCode from "../../widget/ModalBarCode";
import HcidEventCard from "../../widget/HcidEventCard";
import Games from "../../widget/Games";
import { sha256, sha224 } from "js-sha256";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
    components: {
        breadcrumb: BreadCrumb,
        ModalQR,
        ModalBarCode,
        HcidEventCard,
        Games,
        vueDropzone: vue2Dropzone
    },
    data() {
        return {
            base_url: "",
            app_url: "",
            api_url: "",
            titleClass: {
                "sub-title-list-transaksi": true
            },
            selectedTitle: "earn",
            qr: {
                cardNumber: "HCID00099777",
                size: 247
            },
            uploadloader: false,
            points: [],
            loaderpoint: true,
            mobile: false,
            currentPoint: 0,
            user: null,
            errormessage: "Terjadi kesalahan upload",
            showuploaderror: false,
            endpoint: api_url + "/member/point?limit=5&type=tambah",
            dropzoneOptions: {
                url: api_url + "/member/update_foto",
                headers: {
                    Authorization: `Bearer ${asset_token}`
                },
                thumbnailWidth: 150,
                maxFilesize: 1024,
                maxFiles: 1,
                headers: null,
                acceptedFiles: ".jpeg,.jpg,.png,.gif"
            }
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        if (localStorage.getItem("user") != null) {
            this.user = JSON.parse(localStorage.getItem("user"));
            this.getPoint();
        }
        // if (localStorage.getItem('socmed') != null) {
        //     var method = localStorage.getItem('method');
        //     var socmed = localStorage.getItem('socmed');
        //     var data = {
        //         'event': method,
        //         'eventCategory': 'Custom Event',
        //         'eventAction': method,
        //         'eventLabel': socmed,
        //     };
        //     console.log(data);
        //     dataLayer.push(data);
        //     localStorage.setItem('tracker', JSON.stringify(data));
        // }
    },
    methods: {
        // GTM Tracker
        gtmTrackerBtn(pageList) {
            var data = {
                event: "seeMore",
                "eventDetail.category": "Custom Event",
                "eventDetail.action": "See More Detail",
                "eventDetail.label": window.location.href,
                list: pageList
            };
            dataLayer.push(data);
        },
        redeemPointTracker() {
            const track = {
                event: "redeemPoint",
                "eventDetail.category": "Custom Event",
                "eventDetail.action": "Redeem Point Click",
                "eventDetail.label": "Profile HCID"
            };
            dataLayer.push(track);
        },
        seeQrCodeTracker() {
            const track = {
                event: "seeQRCode",
                "eventDetail.category": "Custom Event",
                "eventDetail.action": "Lihat QR Code", // Login Failed,
                "eventDetail.label": "Profile HCID",
                userId: this.user.hcid,
                point: this.currentPoint
            };
            dataLayer.push(track);
        },
        seeBarCodeTracker() {
            const track = {
                event: "seeBarCode",
                "eventDetail.category": "Custom Event",
                "eventDetail.action": "Lihat Bar Code", // Login Failed,
                "eventDetail.label": "Profile HCID",
                userId: this.user.hcid,
                point: this.currentPoint
            };
            dataLayer.push(track);
        },
        // End of GTM Tracker

        changeSelectedClass(data) {
            this.selectedTitle = data;
            if (data == "earn") {
                this.endpoint = api_url + "/member/point?limit=5&type=tambah";
            } else {
                this.endpoint = api_url + "/member/point?limit=5&type=kurang";
            }
            this.getPoint();
        },
        getPoint() {
            this.loaderpoint = true;
            axios
                .get(this.endpoint)
                .then(response => {
                    this.currentPoint = response.data.point;
                    this.points = response.data.data.point;
                    this.loaderpoint = false;

                    if (localStorage.getItem("tracker-login") !== null) {
                        const tracker = JSON.parse(
                            localStorage.getItem("tracker-login")
                        );
                        tracker.point = this.currentPoint;

                        console.log(tracker);

                        dataLayer.push(tracker);
                        localStorage.removeItem("tracker-login");
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        sendingFile(file, xhr, formData) {
            this.uploadloader = true;
            formData.append("_token", token);
            formData.append("user_id", this.user.id);
            this.showuploaderror = false;
        },
        uploadedCompleted(file, response) {
            this.user.avatar = response.data.avatar;
            this.uploadloader = false;
            this.showuploaderror = false;
        },
        uploadError(file, message, xhr) {
            this.uploadloader = false;
            if (message["errors"]) {
                this.errormessage = message["errors"].file[0];
            }
            this.showuploaderror = true;
            this.$refs.myVueDropzone.removeAllFiles();
            console.log();
        }
    }
};
</script>

<style scoped lang="scss">
#hcid-page {
    .error-upload {
        text-align: center;
        background: #c00;
        color: #fff;
        padding: 5px 10px;
        border-radius: 10px;
    }

    .profile-image {
        cursor: pointer;
        position: relative;
        overflow: hidden;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        width: 100px;
        height: 100px;
        display: block;
        margin: 25px auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .profile-image:before {
        content: "Change Photo";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
    }

    #dropzone {
        position: absolute;
        top: 100%;
        left: 0;
        min-height: 100px;
        width: 100%;
        padding: 0;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;

        .dz-preview {
            margin: 0;
        }
    }

    .dropzone .dz-preview {
        margin: 0;
    }

    .profile-image:hover {
        #dropzone {
            top: 0;
        }
    }

    background: #000000;

    .card {
        background: #282828;
        border-radius: 10px;
        color: #ffffff;
    }

    .title-row {
        background: #191919;
        opacity: 0.95;
    }

    .title {
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
        color: #ffffff;
    }

    .poin-head {
        max-height: 43px;
    }

    #poin-amount {
        vertical-align: sub;
    }

    .btn-tukar {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #ffffff !important;
        flex: none;
        order: 0;
        flex-grow: 0;
        border: 1px solid #686868;
        box-sizing: border-box;
        border-radius: 10px;
        height: 28px;
        display: inline-table;
    }

    .btn-view {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #ffffff;
        flex: none;
        order: 1;
        flex-grow: 0;
        margin: 0px 10px;
        background: #e61b33;
        border-radius: 10px;
        height: 28px;
        display: inline-table;
    }

    .btn:hover {
        color: #ffffff;
    }

    .btn-red {
        background: #e61b33;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #ffffff;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 10px;
    }

    .btn-black {
        background: rgba(0, 0, 0, 0.6);
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #ffffff;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 10px;
    }

    .divider-hr {
        border: 1px dashed #b4b4b4;
    }

    .card-info {
        background: #1c1c1c;
        border-radius: 10px;
    }

    .box-avatar {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }

    .profile-img {
        width: 100%;
    }

    .row-name {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #ffffff;
    }

    .row-club {
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
        color: #b4b4b4;
    }

    .sub-title {
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        color: #ffffff;
        border-bottom: 3px solid #ffffff;
        display: inline-flex;
    }

    .btn-see-more {
        background: #282828;
        border-radius: 10px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        color: #ffffff;
        flex: none;
        order: 0;
        flex-grow: 0;
    }

    .btn-redeem {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        color: #ffffff;
        flex: none;
        order: 0;
        flex-grow: 0;
        background: #e61b33;
        border-radius: 10px;
    }

    .sub-title-list-transaksi {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 45px;
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        height: 45px;
        padding: 0 20px;
    }

    .selected-list-transaction {
        border-bottom: 4px solid #e61b33;
    }

    .hr-transaksi {
        opacity: 0.2;
        border: 1px solid #ffffff;
        margin-top: unset;
        margin-bottom: unset;
    }

    .img-poin {
        max-height: 50px;
    }

    .poin-value {
        left: -5px;
        top: 2px;
        position: absolute;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 25px;
        text-align: center;
        color: #000000;
        z-index: 100;
        width: 40px;
        height: 40px;
        font-size: 12px;
    }

    .poin-text {
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        display: block;
    }

    .date-content {
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        color: #b4b4b4;
    }

    .title-content {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #ffffff;
    }

    .col-title {
        text-align-last: justify;
    }

    .title-list-transaksi {
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
        color: #ffffff;
        display: inline-flex;
        margin: unset;
    }

    @media (max-width: 414px) {
        .transaction-redeem {
            display: flex;
            justify-content: space-between;
            width: 100%;
        }
    }

    @media (max-width: 768px) {
        .transaction-redeem {
            display: flex;
            justify-content: space-between;
            width: 100%;
        }

        .card-mobile {
            padding: 0;
            overflow: hidden;

            .box-point {
                background-color: #141414;
            }

            .col-profile-image {
                min-width: 130px;
            }

            .box-avatar {
                width: 70px;
                height: 70px;
                padding: 20px 0;
                margin: 30px auto;
                position: relative;
                right: -15px;
            }

            .row-club {
                font-size: 14px;
            }

            .box-profile {
                padding: 20px 0;
            }

            .coin {
                background-color: #ffeb36;
                width: 20px;
                height: 20px;
                border-radius: 100px;
                display: block;
                position: relative;
                z-index: 10;
                margin: 10px 12px;
            }

            .coin:after {
                content: "";
                width: 24px;
                height: 24px;
                border: 10px solid #d7c41b;
                border-radius: 100px;
                position: absolute;
                left: -5px;
                top: -5px;
                z-index: 5;
                display: none;
            }

            .coin:before {
                content: "";
                width: 26px;
                height: 26px;
                border: 4px solid rgba(0, 0, 0, 0.1);
                border-radius: 100px;
                position: absolute;
                left: -2px;
                top: -2px;
                z-index: 3;
                display: none;
            }
        }

        #poin-amount {
            font-size: 16px;
        }

        .col-profile-image {
            max-width: fit-content;
        }

        .btn-view {
            margin: unset;
            display: table;
            margin-bottom: 0.5rem;
            margin-top: 0.5rem;
        }

        .title {
            padding: 0 !important;
            margin: 0;
            font-size: 24px;
        }

        .img-card {
            max-height: 228.61px;
        }

        .name-card {
            font-size: 16px;
            line-height: 26px;
        }

        .detail-event {
            font-size: 12px;
        }

        .poin-head {
            max-height: 33px;
        }

        .col-left {
            width: auto;
        }

        .poin-value {
            left: -5px;
        }

        .sub-title {
            font-size: 16px;
            line-height: 26px;
        }

        .title-list-transaksi {
            font-size: 20px;
            line-height: 35px;
        }

        .btn-redeem {
            font-size: 12px;
            line-height: 25px;
        }
    }
}
</style>
